import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { ROUTES } from '@utils/constants.js'
import type { AppMode } from '@stores/modeStore.js'

export type NavIconKey =
  | 'inicio'
  | 'jornada'
  | 'etapa'
  | 'checklist'
  | 'ferramenta'
  | 'wiki'
  | 'obra'
  | 'financeiro'
  | 'materiais'
  | 'documentos'
  | 'diario'
  | 'pendencias'
  | 'alertas'
  | 'config'
  | 'contratos'
  | 'contatos'
  | 'cronograma'
  | 'decisoes'
  | 'camera'

export interface NavItemConfig {
  to: string
  label: string
  icon: NavIconKey
  end?: boolean
  showAlertBadge?: boolean
}

export interface NavSection {
  id: string
  label: string
  desc: string
  mode?: AppMode
  items: NavItemConfig[]
}

/** Itens globais — aparecem uma vez no menu hamburger. */
export const APP_NAV_ITEMS: NavItemConfig[] = [
  { to: ROUTES.ALERTAS, label: 'Alertas', icon: 'alertas', showAlertBadge: true },
  { to: ROUTES.CONFIG, label: 'Configurações', icon: 'config' },
]

export const NAV_BY_MODE: Record<AppMode, NavItemConfig[]> = {
  guia: [
    { to: ROUTES.MODULOS, label: 'Jornada', icon: 'jornada', end: true },
    { to: ROUTES.ETAPA, label: GUIA_LABELS.etapaAtual, icon: 'etapa' },
    { to: ROUTES.CHECKLIST_PENDENTES, label: 'Checklists do guia', icon: 'checklist' },
    { to: ROUTES.CALCULADORAS, label: GUIA_LABELS.ferramentasIndex, icon: 'ferramenta' },
    { to: ROUTES.WIKI, label: 'Enciclopédia', icon: 'wiki' },
    { to: ROUTES.CONFIG, label: 'Configurações', icon: 'config' },
  ],
  obra: [
    { to: ROUTES.PAINEL, label: 'Obra', icon: 'obra', end: true },
    { to: ROUTES.FINANCEIRO, label: 'Financeiro', icon: 'financeiro' },
    { to: ROUTES.CONTRATOS, label: 'Contratos e pagamentos', icon: 'contratos' },
    { to: ROUTES.CRONOGRAMA, label: 'Cronograma', icon: 'cronograma' },
    { to: ROUTES.DECISOES, label: 'Memorial de decisões', icon: 'decisoes' },
    { to: ROUTES.DIARIO, label: 'Diário', icon: 'diario' },
    { to: ROUTES.PENDENCIAS, label: 'Tarefas do canteiro', icon: 'pendencias' },
    { to: ROUTES.MATERIAIS, label: 'Materiais', icon: 'materiais' },
    { to: ROUTES.DOCUMENTOS, label: 'Arquivos', icon: 'documentos' },
    { to: ROUTES.CONTATOS, label: 'Contatos da obra', icon: 'contatos' },
    { to: ROUTES.CONFIG, label: 'Configurações', icon: 'config' },
  ],
}

/** Atalhos do rodapé. Guia cabe em 5. Obra passa de 5: o rodapé rola, último slot é seta. */
export const BOTTOM_NAV_BY_MODE: Record<AppMode, NavItemConfig[]> = {
  guia: [
    { to: ROUTES.HOME, label: 'Início', icon: 'inicio', end: true },
    { to: ROUTES.MODULOS, label: 'Jornada', icon: 'jornada' },
    { to: ROUTES.ETAPA, label: 'Etapa', icon: 'etapa' },
    { to: ROUTES.CALCULADORAS, label: 'Ferram.', icon: 'ferramenta' },
    { to: ROUTES.ALERTAS, label: 'Alertas', icon: 'alertas', showAlertBadge: true },
  ],
  obra: [
    { to: ROUTES.PAINEL, label: 'Obra', icon: 'obra', end: true },
    { to: ROUTES.FINANCEIRO, label: 'Gastos', icon: 'financeiro' },
    { to: ROUTES.CONTRATOS, label: 'Contratos', icon: 'contratos' },
    { to: ROUTES.CRONOGRAMA, label: 'Prazos', icon: 'cronograma' },
    { to: ROUTES.DECISOES, label: 'Decisões', icon: 'decisoes' },
    { to: ROUTES.DIARIO, label: 'Diário', icon: 'diario' },
    { to: ROUTES.PENDENCIAS, label: 'Tarefas', icon: 'pendencias' },
    { to: ROUTES.MATERIAIS, label: 'Materiais', icon: 'materiais' },
    { to: ROUTES.DOCUMENTOS, label: 'Arquivos', icon: 'documentos' },
    { to: ROUTES.CONTATOS, label: 'Contatos', icon: 'contatos' },
  ],
}

function drawerItems(items: NavItemConfig[]): NavItemConfig[] {
  return items.filter((item) => item.to !== ROUTES.CONFIG)
}

export const ALL_NAV_SECTIONS: NavSection[] = [
  {
    id: 'guia',
    label: 'Guia',
    desc: 'Orientações, dicas e o que fazer em cada etapa',
    mode: 'guia',
    items: drawerItems(NAV_BY_MODE.guia),
  },
  {
    id: 'obra',
    label: 'Obra',
    desc: 'Gastos, contratos, cronograma e o dia a dia do canteiro',
    mode: 'obra',
    items: drawerItems(NAV_BY_MODE.obra),
  },
  {
    id: 'app',
    label: 'Geral',
    desc: 'Alertas automáticos e configurações',
    items: APP_NAV_ITEMS,
  },
]
